import { render, staticRenderFns } from "./PolicyDefinition.vue?vue&type=template&id=8ee11b14&scoped=true&"
import script from "./PolicyDefinition.vue?vue&type=script&lang=js&"
export * from "./PolicyDefinition.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDefinition.vue?vue&type=style&index=0&id=8ee11b14&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee11b14",
  null
  
)

export default component.exports